module.exports = __webpack_public_path__ + "img/logo.0bfc250c.png";